import styled from "styled-components";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const ChangeProgramStatusWrapper = styled.div`
  .status-field {
    margin-top: 24px;
  }

  .status-container {
    .status-label {
      color: ${COLORS.cirrus_black10};
    }
  }

  .change-status-form {
    padding-bottom: 16px;
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
    padding-right: 16px;
  }

  .form-container {
    padding-left: 16px;
  }

  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .closure-header {
    background-color: ${COLORS.primary_light_blue2};
    margin-top: 24px;
  }

  .form-field {
    padding: 24px 16px 16px 0px;
  }
`;
